import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { BASE_ADMIN_API_URL } from '../../../../config';

const Connect4Context = createContext(null);

export const useConnect4Socket = () => useContext(Connect4Context);

export default function Connect4Provider({ children }) {
    const [socket, setSocket] = useState(null);

    useEffect(() => {
        const s = io(BASE_ADMIN_API_URL + '/connect4', {
            path: '/programmers-sockets',
            transports: ['websocket'],
        });

        s.on('connect', () => {
            setSocket(s);
        });

        s.on('disconnect', () => {
            setSocket(null);
        });

        return () => {
            s.removeAllListeners();
            s.disconnect();
            setSocket(null);
        };
    }, []);

    return (
        <Connect4Context.Provider value={socket}>
            {children}
        </Connect4Context.Provider>
    );
}
